"use client"

import { motion, AnimatePresence } from "motion/react"

type ValidationMessageProps = {
    error?: string | null
    className?: string
}

export function ValidationMessage({ error, className = "" }: ValidationMessageProps) {
    return (
        <AnimatePresence mode="wait">
            {error && (
                <motion.div
                    initial={{ opacity: 0, height: 0, marginTop: 0 }}
                    animate={{ opacity: 1, height: "auto", marginTop: 6 }}
                    exit={{ opacity: 0, height: 0, marginTop: 0 }}
                    style={{ overflow: "hidden" }}
                    className={className}
                >
                    <div style={{
                        fontSize: "0.8125rem",
                        color: "var(--destructive)",
                        display: "flex",
                        alignItems: "center",
                        gap: "0.375rem"
                    }}>
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
                            <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.5" fill="none" />
                            <path d="M7 4v3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                            <circle cx="7" cy="9.5" r="0.5" fill="currentColor" />
                        </svg>
                        {error}
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    )
}
